import classNames from 'classnames'
import classes from './SummarySection.module.scss'

type SummarySectionProps = {
  children?: React.ReactNode
  isLoading?: boolean
    heading: React.ReactNode
    value?: React.ReactNode
    valueColor?: 'gray' | 'green'
}
export function SummarySection (props: SummarySectionProps) {
  const { children, isLoading, heading, value, valueColor } = props
  return (
    <section className={classes.section}>
      <div className={classes.valuesArea}>
        {value && (
          <div className={classNames(classes.values, {
            'ds-u-padding--0': isLoading,
            [`${classes.gray}`]: valueColor === 'gray',
            [`${classes.green}`]: valueColor === 'green'
          })}>
            {value}
          </div>
        )}
      </div>

      <div className={classes.content}>
        <h2 className="ds-text-heading--lg ds-u-margin-bottom--1">{heading}</h2>
        <div>
            {children}
        </div>
      </div>
    </section>
  )
}
